import type { Dispatch } from 'react';
import { createContext } from 'react';
import type { ConnectedData, Dealer } from '../interfaces/header-components.interfaces';
import type { OidcUser } from '../types/oidc-user-info';

interface OidcUserContext {
  readonly oidcUser: OidcUser | null;
  loading: boolean;
  error: string | null;
}

interface DealerContextInterface {
  readonly renderDealerContext: boolean;
  readonly dealerData?: Dealer;
  readonly dealerConnectedNotification: ConnectedData | null;
  readonly removeDealer: (label?: string) => void;
  readonly geoError: GeolocationPositionError | null;
  readonly autoConnectedUnsubscribed: boolean;
  setDealerConnectedNotification?: Dispatch<React.SetStateAction<ConnectedData | null>>;
}

export const OidcUserContext = createContext<OidcUserContext>({} as OidcUserContext);

export const DealerContext = createContext<DealerContextInterface>({} as DealerContextInterface);
